<template>
  <div class="avatar">
    <img :src="src" alt="" v-if="loaded === 'success'" />
    <span v-else-if="!!name" :style="{ fontSize: `${fontSize}px` }">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: "MuiAvatar",
  props: {
    // 头像地址
    src: {
      type: String,
      default: "",
    },
    // 头像地址失效，显示文本
    name: {
      type: String,
      default: "",
    },
    // 文本字体大小，默认10px
    fontSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      loaded: "pending",
    };
  },
  watch: {
    src: {
      handler: function (val) {
        this.loaded = "pending";

        const img = new Image();
        img.src = val;

        img.onload = () => {
          this.loaded = "success";
        };

        img.onerror = () => {
          this.loaded = "failure";
        };
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  text-align: center;
  background-color: #bdbdbd;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  span {
    color: #fff;
  }
}
</style>
